export default "__VITE_ASSET__C0q$s8UZ__"